import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-20 bg-[#1a3622] border-t border-[#2c4c3b]" data-id="element-56">
      <div className="container mx-auto px-4 text-center max-w-4xl" data-id="element-57">
        <h2 className="text-3xl font-extrabold text-[#d4af37] mb-8" data-id="element-58">
          EL PRÓXIMO LUNES PODÉS SEGUIR BUSCANDO... O PODÉS TENER TODO LISTO
          DESDE HOY.
        </h2>

        <div className="text-white text-lg mb-10 space-y-4 max-w-2xl mx-auto text-left md:text-center" data-id="element-59">
          <ul className="space-y-2 text-[#cbd5e1] text-base" data-id="element-60">
            <li className="flex items-start gap-2" data-id="element-61">
              <span className="text-[#d4af37]" data-id="element-62">▸</span> Sin más noches buscando
              PDFs sueltos que nunca están completos
            </li>
            <li className="flex items-start gap-2" data-id="element-63">
              <span className="text-[#d4af37]" data-id="element-64">▸</span> Sin más estudiar con
              apuntes que no cubren todos los temas
            </li>
            <li className="flex items-start gap-2" data-id="element-65">
              <span className="text-[#d4af37]" data-id="element-66">▸</span> Sin más clases
              preparadas a último momento con material que no alcanza
            </li>
            <li className="flex items-start gap-2" data-id="element-67">
              <span className="text-[#d4af37]" data-id="element-68">▸</span> Sin más lagunas entre
              agricultura, ganadería, gestión y tecnología
            </li>
            <li className="flex items-start gap-2" data-id="element-69">
              <span className="text-[#d4af37]" data-id="element-70">▸</span> Sin más tiempo perdido
              armando material desde cero
            </li>
          </ul>
        </div>

        <div className="bg-[#2c4c3b] p-6 rounded-xl border border-[#d4af37]/30 mb-10 max-w-3xl mx-auto italic text-[#fdfbf7]" data-id="element-71">
          <p className="mb-2" data-id="element-72">
            El Megapack Educación Agropecuaria y Ganadera 360 no te convierte en
            mejor productor, estudiante o docente. Vos ya tenés las ganas y el
            compromiso.
          </p>
          <p className="font-bold text-[#d4af37]" data-id="element-73">
            Lo que hace el Megapack es darte el sistema completo para que eso se
            note en cada clase, en cada decisión productiva, en cada examen.
          </p>
        </div>

        <p className="text-xl font-bold text-white mb-10" data-id="element-74">
          "El mejor momento para tener este material era al inicio del año. El
          segundo mejor momento es hoy."
        </p>

        <div className="mb-10" data-id="element-75">
          <p className="text-[#d4af37] font-bold uppercase tracking-wider mb-4" data-id="element-76">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown theme="dark" className="scale-110 bg-[#122618] border-[#2c4c3b]" data-id="element-77" />
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-78">
          <div className="min-w-[600px] max-w-3xl mx-auto" data-id="element-79">
            <div className="grid grid-cols-3 gap-4 mb-4 px-4 items-end" data-id="element-80">
              <div data-id="element-81"></div>
              <div className="font-bold text-[#cbd5e1] uppercase text-sm tracking-wider text-center" data-id="element-82">
                🏆 MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360
              </div>
              <div className="font-bold text-white uppercase text-sm tracking-wider text-center flex items-center justify-center gap-1" data-id="element-83">
                ⭐ MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360 + HUERTA Y
                PRODUCCIÓN VEGETAL
              </div>
            </div>

            <div className="space-y-2" data-id="element-84">
              <div className="grid grid-cols-3 gap-4 bg-[#122618]/60 rounded-xl p-4 items-center border border-[#2c4c3b]" data-id="element-85">
                <div className="text-[#cbd5e1] font-medium text-sm" data-id="element-86">Precio</div>
                <div className="text-white font-bold text-center" data-id="element-87">
                  $19.990 ARS
                </div>
                <div className="text-[#d4af37] font-bold text-center text-lg" data-id="element-88">
                  $27.990 ARS
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 bg-transparent p-4 items-center" data-id="element-89">
                <div data-id="element-90"></div>
                <div className="text-center" data-id="element-91">
                  <a href="https://www.centralpack.shop/cart/53830980960574:1" target="_blank" rel="noopener noreferrer" data-id="element-92">
                    <Button size="sm" variant="primary" className="w-full text-xs" data-id="element-93">
                      🟢 QUIERO MI MEGAPACK
                    </Button>
                  </a>
                </div>
                <div className="text-center" data-id="element-94">
                  <a href="https://www.centralpack.shop/cart/53830981026110:1" target="_blank" rel="noopener noreferrer" data-id="element-95">
                    <Button size="sm" variant="primary" className="w-full text-xs" data-id="element-96">
                      🟢 LLEVAR PACK COMPLETO
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-[#cbd5e1] font-medium" data-id="element-97">
          <div className="flex items-center gap-1.5" data-id="element-98">
            <Lock className="w-4 h-4 text-[#d4af37]" data-id="element-99" />
            <span data-id="element-100">Pago seguro en pesos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-101">
            <Zap className="w-4 h-4 text-[#d4af37]" data-id="element-102" />
            <span data-id="element-103">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-104">
            <Shield className="w-4 h-4 text-[#d4af37]" data-id="element-105" />
            <span data-id="element-106">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-107">
            <CreditCard className="w-4 h-4 text-[#d4af37]" data-id="element-108" />
            <span data-id="element-109">Tarjeta o Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}